export default __webpack_public_path__ + "static/media/headphones.5151d998.png";